import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisitSourceService } from '../services/visit-source.service';

@Injectable({
   providedIn: 'root'
})
export class StoreListService {

   baseUrl: string = environment.apiUrl;

   constructor(private http: HttpClient, private visitSource: VisitSourceService) {

   }

   getAllStoreLocation(): Observable<any[]> {
      return this.http.get<any[]>(this.baseUrl + '/api/Store/GetAllStoreLocation');
   }

   getStoreByLoaction(location: string, cat: string, brand: string = ''): Observable<any> {
      return this.http.get<any>(this.baseUrl + `/api/Store/GetStoreByLoaction?location=${location}&cat=${cat || ''}&brand=${brand || ''}`);
   }

   getStoreDetail(slug: string): Observable<any> {
      return this.http.get<any>(this.baseUrl + `/api/Store/GetStoreDetails?slug=${slug}`);
   }

   /// A seller's public shop page (ShopPages on the server): name, pictures, about, where it is, links, products on sale.
   /// A 404 when no shop has a page at the slug.
   getShop(slug: string): Observable<any> {
      return this.http.get<any>(this.baseUrl + '/api/Store/Shop/' + encodeURIComponent(slug || ''));
   }

   /// Applying, step one: the application is checked and a code texted to its phone (StoreController.ApplyCode).
   applyCode(model): Observable<any> {
      return this.http.post<any>(environment.apiUrl + `/api/Store/ApplyCode`, model);
   }

   /// Claiming, step one: as applyCode, for a claim.
   claimCode(model): Observable<any> {
      return this.http.post<any>(environment.apiUrl + `/api/Store/ClaimCode`, model);
   }

   /// An application carries where its sender first came from (VisitSourceService), for the owner's Shop Requests page.
   newStoreRequest(model): Observable<any> {
      return this.http.post<any>(environment.apiUrl + `/api/Store/NewStoreRequest`, { ...model, Source: this.visitSource.current() });
   }

   verifyStoreRequest(model): Observable<any> {
      return this.http.post<any>(environment.apiUrl + `/api/Store/VerifyStoreRequest`, { ...model, Source: this.visitSource.current() });
   }

   getPendingShops(): Observable<any[]> {
      return this.http.get<any[]>(this.baseUrl + '/api/Store/GetPendingShops');
   }

   takeStoreRequestAction(model): Observable<any> {
      return this.http.post<any>(environment.apiUrl + `/api/Store/VerifyOrRejectShopRequest`, model);
   }

   /// The signed-in seller's own shop, for Shop settings: { Shop } or { Refused }.
   getMyShop(): Observable<any> {
      return this.http.get<any>(this.baseUrl + '/api/Store/MyShop');
   }

   /// Saves the seller's edit of their own shop: { Done, Shop, ProductsRenamed } or { Refused }.
   saveMyShop(model): Observable<any> {
      return this.http.post<any>(this.baseUrl + '/api/Store/UpdateMyShop', model);
   }

   /// The seller's delivery terms and the countries they may serve: { Delivery, ShipTo } or { Refused }.
   getMyDelivery(): Observable<any> {
      return this.http.get<any>(this.baseUrl + '/api/Store/MyDelivery');
   }

   /// Saves the seller's delivery terms: { Done, Delivery, ProductsRefreshed } or { Refused }.
   saveMyDelivery(model): Observable<any> {
      return this.http.post<any>(this.baseUrl + '/api/Store/UpdateMyDelivery', model);
   }

   /// The seller's delivery inside Bangladesh (the "bd-delivery" module): { Delivery } or { Refused }.
   getMyBdDelivery(): Observable<any> {
      return this.http.get<any>(this.baseUrl + '/api/Store/MyBdDelivery');
   }

   /// { Done, Delivery, ProductsRefreshed, Note, SentForCheck } or { Refused }.
   saveMyBdDelivery(model: any): Observable<any> {
      return this.http.post<any>(this.baseUrl + '/api/Store/UpdateMyBdDelivery', model);
   }

   /// A logo ('logo') or a cover ('cover') for the seller's shop: { success, message, url, webpUrl }. No Content-Type
   /// header on purpose: the browser has to add the multipart boundary itself.
   uploadShopImage(file: File, kind: string): Observable<any> {
      const form = new FormData();
      form.append('files', file, file.name);
      form.append('kind', kind || 'logo');
      return this.http.post<any>(this.baseUrl + '/api/Image/UploadShopImage', form);
   }

   /// The same upload, with its progress (SlImageDropComponent).
   uploadShopImageWithProgress(file: File, kind: string): Observable<HttpEvent<any>> {
      const form = new FormData();
      form.append('files', file, file.name);
      form.append('kind', kind || 'logo');
      return this.http.post<any>(this.baseUrl + '/api/Image/UploadShopImage', form, { reportProgress: true, observe: 'events' });
   }
}
